import React, { useState, useEffect } from "react";
import { Layout } from "antd";
import { useLocation } from "react-router-dom";
import Sidebar from "../Sidebar";
import Navbar from "../Navbar";
import "./style.css";

const { Content } = Layout;

const AppLayout = ({ children, setUser, user }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [pageTitle, setPageTitle] = useState("Dashboard");

  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    if (path.includes("/overview")) setPageTitle("Overview");
    else if (path.includes("/event-calendar")) setPageTitle("Event Calendar");
    else if (path.includes("/add-client")) setPageTitle("Add Client");
    else if (path.includes("/client-list")) setPageTitle("Client List");
    else if (path.includes("/event")) setPageTitle("Event");
    else if (path.includes("/add-new-event"))
      setPageTitle("Add New Event Details");
    else if (path.includes("/view-event-detail"))
      setPageTitle("Event Detail View");
    else if (path.includes("/view-client-detail"))
      setPageTitle("Client Details");
    else setPageTitle("Dashboard");
  }, [location.pathname]);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        breakpoint="lg"
        setUser={setUser}
        user={user}
      />

      <Layout
        className="site-layout"
        style={{
          marginLeft: collapsed ? 0 : 276,
          transition: "margin-left 0.5s",
          cursor: "pointer",
        }}
      >
        <Navbar
          title={pageTitle}
          collapsed={collapsed}
          setCollapsed={setCollapsed}
        />

        <Content>{children}</Content>
      </Layout>
    </Layout>
  );
};

export default AppLayout;
